import { render } from "./FamilyMemberCard.vue?vue&type=template&id=e7bb807e"
import script from "./FamilyMemberCard.vue?vue&type=script&lang=js"
export * from "./FamilyMemberCard.vue?vue&type=script&lang=js"

import "./FamilyMemberCard.vue?vue&type=style&index=0&id=e7bb807e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__